"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/components");
var _vuex = require("vuex");
var _auth = require("@/utils/auth");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  components: {
    Card: _components.Card,
    AppInput: _components.AppInput
  },
  props: {
    showWarning: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      idService: null,
      listPerguntasRespostas: [{
        title: null,
        description: null
      }]
    };
  },
  created: function created() {
    var id = this.$route.params.id;
    if (id) {
      this.idService = id;
      this.getDetails();
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchDetailService', 'fetchFAQ', 'createFAQ', 'updateFAQ', 'deleteFAQ'])), {}, {
    getDetails: function () {
      var _getDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var list;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!this.idService) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return this.fetchFAQ(this.idService);
            case 1:
              list = _context.v;
              if (list.data && list.data.length) {
                this.listPerguntasRespostas = list.data;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getDetails() {
        return _getDetails.apply(this, arguments);
      }
      return getDetails;
    }(),
    addNewQuestion: function addNewQuestion() {
      this.listPerguntasRespostas.push({
        title: null,
        description: null
      });
    },
    removeLineQuestion: function removeLineQuestion(index) {
      this.listPerguntasRespostas.splice(index, 1);
    },
    checkForm: function () {
      var _checkForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this = this;
        var _dataUser$user, _dataUser$user2, dataUser, mensagem, listBDs, promises;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!this.validaInputs()) {
                _context3.n = 1;
                break;
              }
              this.$buefy.toast.open({
                duration: 5000,
                message: "Por favor, verifique se n\xE3o h\xE1 campos vazios!",
                position: 'is-top',
                type: 'is-danger'
              });
              _context3.n = 4;
              break;
            case 1:
              if (!this.listPerguntasRespostas.length) {
                _context3.n = 4;
                break;
              }
              dataUser = (0, _auth.getUser)();
              mensagem = null; // Configuração do Google Analytics
              this.$gtag.config({
                'user_id': dataUser === null || dataUser === void 0 ? void 0 : (_dataUser$user = dataUser.user) === null || _dataUser$user === void 0 ? void 0 : _dataUser$user._id,
                'user_name': dataUser === null || dataUser === void 0 ? void 0 : (_dataUser$user2 = dataUser.user) === null || _dataUser$user2 === void 0 ? void 0 : _dataUser$user2.name
              });
              _context3.n = 2;
              return this.fetchFAQ(this.idService);
            case 2:
              listBDs = _context3.v;
              promises = this.listPerguntasRespostas.map(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(faq) {
                  var listBD, _dataUser$user3, _dataUser$user4, payload, _dataUser$user5, _dataUser$user6, _payload;
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.n) {
                      case 0:
                        listBD = listBDs.data.find(function (el) {
                          return el._id === faq._id;
                        });
                        if (!listBD) {
                          _context2.n = 3;
                          break;
                        }
                        if (!(listBD.title !== faq.title || listBD.description !== faq.description)) {
                          _context2.n = 2;
                          break;
                        }
                        payload = {
                          title: faq.title,
                          description: faq.description
                        };
                        _context2.n = 1;
                        return _this.updateFAQ({
                          payload: payload,
                          assetPlanId: faq._id
                        });
                      case 1:
                        mensagem = 'FAQ alterada com sucesso!';
                        // Evento do Google Analytics
                        _this.$gtag.event('update_faq_documentation_service', {
                          'event_category': 'service',
                          'event_label': 'alteração de faq serviço',
                          'value': {
                            'user_id': dataUser === null || dataUser === void 0 ? void 0 : (_dataUser$user3 = dataUser.user) === null || _dataUser$user3 === void 0 ? void 0 : _dataUser$user3._id,
                            'user_name': dataUser === null || dataUser === void 0 ? void 0 : (_dataUser$user4 = dataUser.user) === null || _dataUser$user4 === void 0 ? void 0 : _dataUser$user4.name
                          }
                        });
                      case 2:
                        _context2.n = 5;
                        break;
                      case 3:
                        // Se a FAQ não existe no servidor, executo o create
                        _payload = {
                          faqs: [{
                            title: faq.title,
                            description: faq.description
                          }]
                        };
                        _context2.n = 4;
                        return _this.createFAQ({
                          payload: _payload,
                          idService: _this.idService
                        });
                      case 4:
                        mensagem = 'FAQ criada com sucesso!';
                        // Evento do Google Analytics
                        _this.$gtag.event('create_faq_documentation_service', {
                          'event_category': 'service',
                          'event_label': 'criação de faq serviço',
                          'value': {
                            'user_id': dataUser === null || dataUser === void 0 ? void 0 : (_dataUser$user5 = dataUser.user) === null || _dataUser$user5 === void 0 ? void 0 : _dataUser$user5._id,
                            'user_name': dataUser === null || dataUser === void 0 ? void 0 : (_dataUser$user6 = dataUser.user) === null || _dataUser$user6 === void 0 ? void 0 : _dataUser$user6.name
                          }
                        });
                      case 5:
                        return _context2.a(2);
                    }
                  }, _callee2);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
              _context3.n = 3;
              return Promise.all(promises);
            case 3:
              this.$buefy.toast.open({
                message: mensagem,
                type: 'is-success',
                duration: 5000
              });
              this.$emit('update:showWarning', true);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function checkForm() {
        return _checkForm.apply(this, arguments);
      }
      return checkForm;
    }(),
    confirmDelete: function confirmDelete(idx, item) {
      if (item._id) {
        this.$buefy.modal.open({
          parent: this,
          component: _components.ModalWarning,
          hasModalCard: true,
          trapFocus: true,
          props: {
            text: 'Deseja realmente exluir',
            action: this.deleteFaqBD,
            name: 'esse item',
            idItem: item._id,
            idSecond: idx
          }
        });
      } else {
        this.removeLineQuestion(idx);
      }
    },
    deleteFaqBD: function () {
      var _deleteFaqBD = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(id, index) {
        var data;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return this.deleteFAQ(id);
            case 1:
              data = _context4.v;
              if (data) {
                this.removeLineQuestion(index);
                this.getDetails();
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function deleteFaqBD(_x2, _x3) {
        return _deleteFaqBD.apply(this, arguments);
      }
      return deleteFaqBD;
    }(),
    validaInputs: function validaInputs() {
      return this.listPerguntasRespostas.some(function (item) {
        return !item.title || !item.description;
      });
    }
  })
};